import { Pipe, PipeTransform } from '@angular/core';

/**
 * Displays a fallback string (default: "-") when the value is null, undefined, or empty.
 *
 * @usageNotes
 * ```html
 * {{ value | emptyDash }}        <!-- outputs "-" when value is null/undefined/'' -->
 * {{ value | emptyDash:'N/A' }}  <!-- outputs "N/A" as custom fallback -->
 * ```
 */
@Pipe({
  name: 'emptyDash',
})
export class EmptyDashPipe implements PipeTransform {
  transform(value: unknown, fallback = '-'): unknown {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }
    return value;
  }
}
